module.exports = __webpack_public_path__ + "static/media/last_page_new.6a6b212a.jpg";